// Lazy load components only when they're used on the page
// This improves initial page load performance

// Accordion
if (document.querySelector('drop-down') || document.querySelector('accordion-group')) {
  import('./accordion.js');
}

// Added-to-cart notification
if (document.querySelector('cart-notification')) {
  import('./cart-notification.js');
}

// Complementary Products
if (document.querySelector('complementary-products')) {
  import('./complementary-products.js');
}

// Featured Product Slider
if (document.querySelector('featured-product-slider')) {
  import('./featured-product-slider.js');
}

// Card Promo Text
if (document.querySelector('card-promo-text')) {
  import('./card-promo-text.js');
}

// Reveal Articles
if (document.querySelector('reveal-articles')) {
  import('./reveal-articles.js');
}

// Sticky ATC (bar + the select-a-size bottom sheet it opens)
if (document.querySelector('sticky-atc')) {
  import('./sticky-atc.js');
}

// Buy button availability state — tells the sold-out button apart from "select a size"
if (document.querySelector('buy-buttons')) {
  import('./buy-buttons-state.js');
}

// Swym Wishlist
if (document.querySelector('swym-custom-wishlist')) {
  import('./swym-wishlist.js');
}

// Selected option label — the "SIZE 24" echo in the variant picker's header row
if (document.querySelector('selected-option-label')) {
  import('./selected-option-label.js');
}

// Whole-dollar product price — undoes theme.js re-adding ".00" on variant change
if (document.querySelector('price-list[role="region"]')) {
  import('./whole-dollar-price.js');
}

// Mobile gallery lightbox — tap-to-open below `md`, where theme.js only listens for the
// zoom button the comps removed (G3/I3)
if (document.querySelector('product-gallery[allow-zoom]')) {
  import('./mobile-gallery-lightbox.js');
}

// Markdown flag beside the price — keeps its percentage right on variant change
if (document.querySelector('discount-flag')) {
  import('./discount-flag.js');
}

// Reviews / FAQ — histogram, verified badge, fit pills and see-all label inside
// the Okendo widget (D2/D4/D5/D6)
if (document.querySelector('.avara-reviews-faq__reviews-slot')) {
  import('./avara-reviews-enhance.js');
}

// Collection description more/less toggle
if (document.querySelector('more-less')) {
  import('./more-less-text.js');
}

// Featured Product Scroll
if (document.querySelector('featured-product-scroll')) {
  import('./featured-product-scroll.js');
}

// Product Card Slider
if (document.querySelector('product-card-slider')) {
  import('./product-card-slider.js');
}

// Lookbook Card - hover image swap on tap / keyboard
if (document.querySelector('lookbook-card')) {
  import('./lookbook-card.js');
}

// Quick Buy Size Slider on Product Card _ Load unconditionally to avoid timing issues with Nosto product cards
import('./slider-arrows.js');

// Quick Buy Feedback - Load unconditionally to avoid timing issues
import('./quick-buy-feedback.js');

// Collection Swatch Select - load unconditionally for dynamic content
import('./collection-swatch-selector.js');

// Carousel arrows for accessibility - load unconditionally
import('./carousel-accessibility.js');

// Announcement Bar Pause Button - for ADA compliance with moving content
if (document.querySelector('.announcement-bar__pause-button')) {
  import('./announcement-bar-pause.js');
}

// Cart Property Sync - syncs line-item properties with current product tags
if (document.querySelector('cart-drawer')) {
  import('./cart-property-sync.js');
}

// Stale Tab Refresh - refreshes the page when cart drawer opens after tab has been inactive
if (document.querySelector('cart-drawer')) {
  import('./stale-tab-refresh.js');
}

// Nosto PLP - reinsert marketing units, and reveal the server-rendered grid if
// Nosto never loads. The skeleton module is keyed off the durable target (not the
// <nosto-skeleton> element) so skeletons inserted by later facet re-renders still
// get their fallback even when the initial render had none.
if (document.querySelector('#nosto-target-plp')) {
  import('./nosto-marketing-units.js');
  import('./nosto-skeleton.js');
}

// Timeline Reveal is loaded in the footer (kept in assets folder)
